import { Collection } from "@tblabs/truffle";
import { ProductOption } from "./ProductOption";


export class ProductOptions
{
    public List = new Collection<ProductOption>();
}
